import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import TankCreate from "./TankCreate";
import TankDetails from './TankDetails';
import TankList from "./TankList";
import EditTank from "./EditTank";
import TankView from "./TankView";
import DemoTankView from "./DemoTankView";
import TankFlowView from "./TankFlowView";
import DemoTankFlowView from "./DemoTankFlowView";

export default function WaterTank() {
  return (
    <Switch>
      <Redirect exact={true} from="/aprt-customer" to="/aprt-customer/customer-list" />

      {/* Layout */}
      <Route exact={true} path="/water-tank/tank-list" component={TankList} />
      <Route exact={true} path="/water-tank/tank-details" component={TankDetails} />
      <Route exact={true} path="/water-tank/tank-create" component={TankCreate} />
      <Route exact={true} path="/water-tank/tank-edit" component={EditTank} />
      <Route exact={true} path="/water-tank/tank-view" component={TankView} />
      <Route exact={true} path="/water-tank/demo-tank-view" component={DemoTankView} />
      <Route exact={true} path="/water-tank/tank-flow-view" component={TankFlowView} />
      <Route exact={true} path="/water-tank/demo-tank-flow-view" component={DemoTankFlowView} />
    </Switch>
  );
}
